import { render, staticRenderFns } from "./EmployeePageHeader.vue?vue&type=template&id=5e79d2fc&scoped=true"
import script from "./EmployeePageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeePageHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeePageHeader.vue?vue&type=style&index=0&id=5e79d2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e79d2fc",
  null
  
)

export default component.exports